import {useState} from 'react';
import {reportFilename,reportHtml,reportMarkdown} from '@/lib/reportExports.mjs';
export default function ReportExport({getReport,label}) {
  const [message,setMessage]=useState('');
  const download=()=>{
    try {
      const report=getReport();
      const url=URL.createObjectURL(new Blob([reportMarkdown(report)],{type:'text/markdown;charset=utf-8'}));
      const link=document.createElement('a');link.href=url;link.download=reportFilename(report,'md');document.body.appendChild(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
      setMessage('Markdown download started.');
    } catch {setMessage('The report could not be exported. Please try again.');}
  };
  const pdf=()=>{
    // Open synchronously from the user's click so browser popup rules are respected.
    const popup=window.open('','_blank');
    if(!popup){setMessage('Allow a new tab for this site, then try Export PDF again.');return;}
    try {
      const report=getReport();popup.opener=null;popup.document.write(reportHtml(report));popup.document.close();
      const print=()=>{popup.focus();popup.print();};
      popup.document.getElementById('save-pdf').addEventListener('click',print);
      popup.requestAnimationFrame(()=>popup.requestAnimationFrame(print));
      setMessage('PDF view opened. Choose Save as PDF in the print dialog.');
    } catch {popup.close();setMessage('The PDF view could not be opened. Please try again.');}
  };
  return <div className="ss-report-controls" aria-label={`Export ${label}`}>
    <div role="group" aria-label={`Export ${label}`}><button type="button" onClick={pdf}>Export PDF</button><button type="button" onClick={download}>Download Markdown</button></div>
    <p role="status" aria-live="polite">{message}</p>
  </div>;
}
